import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'
import auth from '@/utils/auth'
// 统一请求路径前缀
const base = process.env.VUE_APP_BASE_API
// 超时设定
axios.defaults.timeout = 120000

axios.interceptors.request.use(
  config => {
    // console.log('请求拦截器数据', config)
    return config
  },
  err => {
    Message.error('请求超时')
    return Promise.resolve(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    //  console.log('返回结果：'+JSON.stringify(response))
    const data = response.data

        // 根据返回的code值来做不同的处理(和后端约定)
        switch (data.code) {
            case 401:
            auth.removeToken().then(() => { // 清除已登录状态
                router.push('/login')
            })
            break
            case 403:
            // 没有权限
            if (data.msg !== null) {
                Message.error(data.msg)
            } else {
                Message.error('未知错误')
            }
            break
            case 500:
            // 错误
            if (data.msg !== null) {
                Message.error(data.msg)
            } else {
                Message.error('未知错误')
            }
            break
            case 10000:
                auth.removeToken();
                router.replace("/login");
                break
            default:
            // console.log('返回结果：'+ JSON.stringify(data) )
            return data
        }
        return Promise.reject(new Error(response.msg || 'Error'))
   
  },
  error => {
    // console.log('：'+ error.toString() ) 
    // 返回状态码不为200时候的错误处理
    // Message.error(error.toString())
    if (error.request.responseURL.indexOf('/sys/security/needLogin')!=-1) {
        auth.removeToken().then(() => { // 清除已登录状态
        router.push('/login')
      })
    }
    // return err
    return Promise.reject(error)
  }
)

export const getRequest = (url, params) => {
  const token = auth.getToken()
//   console.log(`-------------------${base}${url}`)
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params,
    headers: {
        token: token
    }
  })
}

export const postRequest = (url, params) => {
  const token = auth.getToken()
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = ''
        for (const it in data) {
          ret +=
            encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      token: token
    }
  })
}

export const post = (url, params) => {
    // console.log('base:'+base)
  const token = auth.getToken()
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      // 'Content-Type': 'multipart/form-data',
      token: token
    }
  })
}

export const putRequest = (url, params) => {
  const token = auth.getToken()
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = ''
        for (const it in data) {
          ret +=
            encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      token: token
    }
  })
}

export const deleteRequest = (url, params) => {
  const token = auth.getToken()
  return axios({
    method: 'delete',
    url: `${base}${url}`,
    params: params,
    headers: {
      token: token
    }
  })
}

export const importRequest = (url, params) => {
  const token = auth.getToken()
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      token: token
    }
  })
}

export const uploadFileRequest = (url, params) => {
  const token = auth.getToken()
  return axios({
    method: 'post',
    url: `${base}${url}`,
    params: params,
    headers: {
      token: token
    }
  })
}

export const getDownLoadUrl = url => {
  const token = auth.getToken()
  return base + url + '?token=' + token
}

export const uploadFileRequestJianCai = (url, params) => {
  const token = auth.getToken()
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
      contentType: false,
      processData: false,
      token: token
    }
  })
}

export const postBodyRequest = (url, params) => {
  const token = auth.getToken()
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      token: token
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/axios.js